import type { OpenActivityTypeForm } from './typings'

export const openActivityTypeFormActionCreator = (): OpenActivityTypeForm => ({
  type: 'activityTypeForm/openForm',
})
